import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { JobGeneralRepository } from '@data/job-general/job-general.store';
import { Logger } from '@shared/util/logger.util';

/**
 * Resolves once the job-general data is loaded. `loadAll()` is cache-aware
 * (skips the request when already cached), so a prior load resolves immediately;
 * otherwise resolution waits for the load instead of racing a fire-and-forget
 * subscription against a decoupled success flag.
 */
export const jobGeneralResolver: ResolveFn<boolean> = () => {
  const jobGeneralRepo = inject(JobGeneralRepository);
  return jobGeneralRepo.loadAll().pipe(
    map(() => true),
    catchError((error) => {
      Logger.error(error);
      return of(false);
    }),
  );
};
